import React, { Component } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import CleavePhone from 'cleave.js/dist/addons/cleave-phone.fr.js'
import swal from 'sweetalert2'
import getAllUrlParams from '../util'

import {
  ZAPIER_COMMANDE as zapier_c,
  ZAPIER_DEMANDE as zapier_d,
} from '../constants'

const LongForm = styled.div`
  #time {
    margin-bottom: 0;
  }
  .form-line {
    display: flex;
    .form-flex-item {
      padding: 0 5px;
    }
  }
  .particulier {
    width: 200px;
    border-radius: 2px;
    text-align: center;
    margin: 40px auto;
    padding: 20px 0;
    background: white;
    box-shadow: 0px 20px 40px -17px rgba(0, 0, 0, 0.3);
    transition: 0.3s all;
    &:hover {
      box-shadow: 0px 20px 40px -17px rgba(0, 0, 0, 0.5);
    }
  }
  .form-container {
    max-width: 350px;
    margin: auto;
    padding: 20px;
    border-radius: 3px;
    /* background: rgba(0, 0, 0, 0.2); */
    .form-title {
      text-align: center;
      margin-bottom: 15px;
      /* font-family: 'Titillium Web', serif; */
      /* text-transform: uppercase; */
    }

    .types {
      display: flex;
      justify-content: space-between;
      .type {
        display: block;
        width: 49%;
        margin-bottom: 20px;
        height: 40px;
        border: none;
        cursor: pointer;
        outline: none;
        border-radius: 2px;
        transition: 0.5s all;
        &.selected {
          background: white;
          color: black;
          box-shadow: 0px 12px 20px -10px rgba(0, 0, 0, 0.1);
          &:hover {
            box-shadow: 0px 12px 20px -10px rgba(0, 0, 0, 0.3);
          }
        }
        &.not-selected {
          background: none;
          color: #999;
          &:hover {
            background: #e8e8e8;
          }
        }
      }
    }
    label {
      font-size: 12px;
      display: inline-block;
      margin-bottom: 5px;
    }
    input,
    button,
    select,
    option,
    textarea {
      font-family: 'Titillium Web', sans-serif;
    }
    input,
    select,
    textarea {
      display: block;
      padding-left: 10px;
      border: none;
      box-sizing: border-box;
      border-bottom: 1px solid lightgray;
      width: 100%;
      border-radius: 3px;
      height: 30px;
      margin-bottom: 10px;
      outline: none;
      &:focus {
        border-bottom: 1px solid grey;
      }
      &::placeholder {
        font-size: 12px;
        color: #bbb;
      }
    }

    textarea {
      height: auto;
      &::placeholder {
        font-size: 12px;
        color: #bbb;
      }
    }

    .long-form-footer {
      text-align: right;
      margin-top: 20px;
    }

    .long-form-previous {
      color: #999;
      margin-right: 10px;
      cursor: pointer;
    }

    .submit {
      display: block;
      margin: auto;
      padding: 0 15px;
      color: white;
      background: #fc4c4c;
      border: none;
      border-radius: 2px;
      height: 40px;
      font-size: 1em;
      /* box-shadow: 0px 11px 22px -8px rgba(0, 0, 0, 0.4); */
      transition: 0.2s all;
      outline: none;
      cursor: pointer;
      &:hover {
        background: #da3535;
      }
      &.long-form-button {
        display: inline-block;
        text-align: center;
        /* height: 40px; */
        line-height: 40px;
        width: 110px;
      }
    }
  }
  .first-form-inputs {
    margin-bottom: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
    .step {
      text-align: center;
      cursor: pointer;
      flex: 1;
      color: #ababab;
      .step-number {
        font-weight: 700;
      }
      .step-text {
        font-size: 12px;
      }
      .step-bar {
        height: 5px;
        background: #ddd;
        margin: auto;
        margin-top: 5px;
        &.first-bar {
          border-radius: 10px 0 0 10px;
        }
        &.second-bar {
          margin: 5px 3px 0;
        }
        &.last-bar {
          border-radius: 0 10px 10px 0;
        }
      }

      &.selected-step {
        color: #fc4c4c;
        .step-bar {
          background: #fc4c4c;
        }
      }
    }
  }
  @media screen and (max-width: 850px) {
    .form-container {
      border-radius: 0;
      max-width: initial;
    }
  }
`

class _LongForm extends Component {
  state = {
    answers: {},
  }

  toggleParticulier = value => {
    this.setState({ particulier: value })
  }

  submit = e => {
    e.preventDefault()
    let urlParams = getAllUrlParams()
    let {
      url_params = '',
      utm_source = '',
      utm_medium = '',
      utm_campaign = '',
      utm_term = '',
    } = urlParams
    let utm = { url_params, utm_source, utm_medium, utm_campaign, utm_term }
    this.state.answers.date =
      this.state.answers.date.substring(0, 2) +
      '/' +
      this.state.answers.date.substring(2, 4) +
      '/' +
      this.state.answers.date.substring(4)

    // gtag('event', 'short-form')
    let data = { ...this.state.answers, ...utm }

    if (!data.event && !this.props.openedBy) data.event = 'cocktail'
    if (!data.time && this.props.openedBy) data.time = '8'
    if (this.props.openedBy) data.menu = this.props.openedBy

    // console.log(data)
    let zapier = this.props.openedBy ? zapier_c : zapier_d

    axios
      .get(zapier, {
        params: { ...data },
      })
      .then(() => {
        this.props.closeModal()
        swal({
          type: 'success',
          title: 'Merci pour votre demande !',
          confirmButtonColor: '#fc4c4c',
          text:
            'Nous revenons vers vous sous 24h avec un menu conçu par des artisans locaux soigneusement sélectionnés.',
          footer:
            "Si vous avez la moindre question d'ici là, n'hésitez pas à nous appeler au 01 76 44 04 41 !",
        })
      })
  }

  inputChangeHandler = event => {
    const { answers } = this.state
    const { id, rawValue, value } = event.target
    this.setState({
      answers: {
        ...answers,
        [id]: rawValue || value,
      },
    })
  }

  getInputValue = id => {
    return this.state.answers[id] || ''
  }

  render() {
    const times = []
    for (let i = 8; i < 22; i++) {
      times.push(
        <option value={i} key={i}>
          {i}:00
        </option>
      )
    }
    const { particulier, step } = this.state
    const shortFormHeader = (
      <div>
        <div className="form-title">Obtenez un devis gratuit</div>
      </div>
    )

    const shortForm = (
      <div className="first-form-inputs">
        <div className="form-line">
          <div className="form-flex-item">
            <label htmlFor="nom">Nom</label>
            <Cleave
              required
              value={this.getInputValue('nom')}
              onChange={this.inputChangeHandler}
              id="nom"
            />
          </div>
          {this.props.openedBy ? (
            <div className="form-flex-item">
              <label htmlFor="prenom">Prenom</label>
              <Cleave
                type="text"
                id="prenom"
                required
                value={this.getInputValue('prenom')}
                onChange={this.inputChangeHandler}
              />
            </div>
          ) : (
            <div className="form-flex-item">
              <label htmlFor="event">Je veux organiser un ...</label>
              <select
                id="event"
                value={this.getInputValue('event')}
                onChange={this.inputChangeHandler}
              >
                <option value="cocktail">Cocktail</option>
                <option value="apero-informel">Apéritif informel</option>
                <option value="buffet-dej-diner">
                  Buffet déjeuner / dîner
                </option>
                <option value="seminaire">Séminaire</option>
                <option value="meetup-afterwork">Meetup / Afterwork</option>
                <option value="petit-dej">Petit-déjeuner</option>
                <option value="autre">Autre</option>
              </select>
            </div>
          )}
        </div>
        <div className="form-line">
          <div className="form-flex-item">
            <label htmlFor="email">Email</label>
            <input
              value={this.getInputValue('email')}
              onChange={this.inputChangeHandler}
              type="text"
              id="email"
              onInvalid={function() {
                document
                  .getElementById('email')
                  .setCustomValidity('Votre email semble incorrect')
              }}
              onInput={function() {
                document.getElementById('email').setCustomValidity('')
              }}
              pattern="^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$"
              required
            />
          </div>
          <div className="form-flex-item">
            <label htmlFor="phone">Telephone</label>
            <Cleave
              options={{ phone: true, phoneRegionCode: 'FR' }}
              type="text"
              id="phone"
              required
              value={this.getInputValue('phone')}
              onChange={this.inputChangeHandler}
            />
          </div>
        </div>
        <div className="form-line">
          <div className="form-flex-item">
            <label htmlFor="date">Date</label>
            <Cleave
              placeholder="DD/MM/YYYY"
              required
              options={{ date: true, datePattern: ['d', 'm', 'Y'] }}
              value={this.getInputValue('date')}
              onChange={this.inputChangeHandler}
              id="date"
            />
          </div>
          {this.props.openedBy !== 0 && (
            <div className="form-flex-item">
              <label htmlFor="number">Nombre de personnes</label>
              <Cleave
                type="text"
                id="number"
                required
                value={this.getInputValue('number')}
                onChange={this.inputChangeHandler}
              />
            </div>
          )}
        </div>
        {this.props.openedBy !== 0 && (
          <div className="form-line">
            <div className="form-flex-item">
              <label htmlFor="place">Lieu</label>
              <Cleave
                type="text"
                id="place"
                required
                value={this.getInputValue('place')}
                onChange={this.inputChangeHandler}
              />
            </div>
            <div className="form-flex-item">
              <label htmlFor="time">Heure de l'événement*</label>
              <select
                id="time"
                value={this.getInputValue('time')}
                onChange={this.inputChangeHandler}
              >
                {times}
              </select>
              <label htmlFor="time">Arrondissez à l'heure inférieure</label>
            </div>
          </div>
        )}
      </div>
    )

    const shortFormFooter = (
      <div>
        <button type="submit" className="submit">
          Demander un devis gratuit
        </button>
      </div>
    )

    return (
      <LongForm isParticulier={particulier}>
        <div className="form-container">
          {shortFormHeader}
          <form onSubmit={this.submit}>
            {shortForm}
            {shortFormFooter}
          </form>
        </div>
      </LongForm>
    )
  }
}

export default _LongForm



// WEBPACK FOOTER //
// ./src/components/LongForm.js